<div class="existing-dealer-list-container">
  <div class="header">
    <mat-icon class="back-arrow" (click)="goBack()">chevron_left</mat-icon>
    <span class="title">{{ isEditFlow ? 'Edit Dealer Details' : 'Verify mobile number' }}</span>
  </div>

  <div class="dealer-count">
    <span>We have found {{ dealers.length }} existing Agro dealer{{ dealers.length === 1 ? '' : 's' }} for this number.</span>
  </div>

  <div class="dealer-list">
    <div
      class="dealer-card"
      *ngFor="let dealer of dealers"
      (click)="selectExistingRetailer(dealer)"
    >
      <div class="dealer-image-wrapper">
        <img 
        src="{{dealer.retailerShopImage ? dealer.retailerShopImage : '../../../assets/Agri_Shop.svg'}}"
        alt="Dealer Product Image" class="dealer-image" />
      </div>
      <div class="dealer-info">
        <h3 class="dealer-name">{{ dealer.shopName }}</h3>
        <p class="dealer-location">
          <mat-icon class="info-icon">location_on</mat-icon> {{ dealer.state }}, {{dealer.district}}
        </p>
        <p class="dealer-phone">
          <mat-icon class="info-icon">phone</mat-icon> {{ dealer.mobileNumberPrimary }}
        </p>
      </div>
      <mat-icon class="arrow-icon">chevron_right</mat-icon>
    </div>

    <div *ngIf="isLoading" class="loading-spinner">
      <mat-spinner [diameter]="30"></mat-spinner>
      <p>Loading more dealers...</p>
    </div>
    <div *ngIf="!isLoading && dealers.length === 0" class="no-dealers-message">
      <p>No agro dealers found matching your criteria.</p>
    </div>
  </div>

  <div class="bottom-button-wrapper">
    <button mat-raised-button color="primary" class="add-dealer-button" (click)="generateOtpAndProceed()">
      Continue As New Agro Dealer
    </button>
  </div>

</div>